import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RolesComponent } from './roles.component';
import { RolesCreateComponent } from './roles-create/roles-create.component';
import { RolesListComponent } from './roles-list/roles-list.component';
import { RoleDetailsComponent } from './role-details/role-details.component';
import { RoleEditComponent } from './role-edit/role-edit.component';


const routes: Routes = [

    {
        path: '',
        component: RolesComponent,
        children:
        [
            {
                path: '',component:RolesListComponent       },
            {
                path: 'create',
                component: RolesCreateComponent

            },
            {
                path: 'details/:id',component:RoleDetailsComponent

            },
            {
                path: 'edit/:id',component:RoleEditComponent


            }
        ]
    }
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})


export class RolesRoutingModule { }
// export const rolesroutingComponents = [RolesComponent,
//   RolesCreateComponent, RolesListComponent, RoleEditComponent];
